import { Trans } from "@lingui/react/macro";
import clsx from "clsx";
import { observer } from "mobx-react-lite";

import { Button } from "../../../components/ui-kit/button";
import { Dialog } from "../../../components/ui-kit/dialog";
import { AdminConsole } from "../admin-console";
import styles from "./temporary-password-dialog.module.css";

export const TemporaryPasswordDialog = observer(
  function TemporaryPasswordDialog(props: { admin: AdminConsole }) {
    return (
      <Dialog open={props.admin.tempPasswordPopup}>
        <p className="mt-4 mb-4">
          <Trans>Temporary password for patient:</Trans>
        </p>
        <p className={clsx(styles.password, "mt-4 mb-4")}>
          {props.admin.tempPasswordText}
        </p>
        <p className="mt-4 mb-4">
          <Trans>
            (Password is valid for <strong>2 days</strong>, in the meantime,
            patient has to change it.)
          </Trans>
        </p>
        <p className="mt-4 mb-4">
          <strong>
            <Trans>
              Save this password somewhere, as it cannot be shown again.
            </Trans>
          </strong>
        </p>
        <Button
          onClick={async () => {
            await props.admin.closeTemporaryPasswordPopup();
          }}
        >
          <Trans>Close</Trans>
        </Button>
      </Dialog>
    );
  },
);
